import moment from 'moment';
import { PriorityBar, PriorityType } from '@jda/lui-common-component-library';
import React from 'react';
import _ from 'lodash';
import {
  adminCoulmns,
  providerColumns,
  aggregatorColumns,
  customerColumns,
  freightTrackingColumn,
  customerAccessColumns,
  customTitles,
  carrierCollaborationColumns,
  dynamicCapacityColumns,
  outboundNotificationColumns,
  archiveColumn
} from './columnsType';

const workflowCodeColumn: any = {
  freightTracking: freightTrackingColumn,
  customerAccess: customerAccessColumns,
  carrierCollaboration: carrierCollaborationColumns,
  dynamicCapacity: dynamicCapacityColumns,
  outboundNotification: outboundNotificationColumns
};

const getPriorityStatus: any = (row: any, workflowCode: any) => {
  if (workflowCode === 'freightTracking') {
    if (row?.loadStatus === 'Active') {
      return PriorityType.LOW;
    } else if (
      row?.loadStatus === 'Revalidate' ||
      row?.loadStatus === 'NotFound' ||
      row?.loadStatus === 'Expired' ||
      row?.loadStatus === 'InSufficientData'
    ) {
      return PriorityType.MEDIUM;
    } else if (row?.loadStatus === 'Inactive' || row?.loadStatus === 'Failed ') {
      return PriorityType.CRITICAL;
    } else return PriorityType.DEFAULT;
  } else {
    if (row?.responseHttpStatus >= 500 && row?.responseHttpStatus <= 599) {
      return PriorityType.CRITICAL;
    } else if (row?.responseHttpStatus >= 400 && row?.responseHttpStatus <= 499) {
      return PriorityType.MEDIUM;
    } else if (row?.responseHttpStatus >= 200 && row?.responseHttpStatus <= 299) {
      return PriorityType.LOW;
    } else if (row?.retryStatus !== 'COMPLETED' && row?.retryStatus !== null) {
      return PriorityType.DEFAULT;
    } else return PriorityType.LOW;
  }
};

const setTitle = (workflowCode: string, field: string) => {
  return customTitles?.[workflowCode]?.[field];
};

const allcolumns = (classes: any, workflowCode?: string, timeZone?: string) => {
  return [
    {
      title: 'Priority',
      field: 'priority',
      // Type checking is not handled in material-table
      // This fix will be available soon. It will be removed once fix is available.
      width: 5,
      sorting: false,
      cellStyle: { padding: 8, zIndex: 1 },
      headerStyle: {
        padding: 0
      },
      render: (rowData: any) => {
        return (
          <PriorityBar priority={getPriorityStatus(rowData, workflowCode)} className={classes.priorityBarSettings} />
        );
      }
    },
    {
      title: 'Operation',
      field: 'operation',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => {
        return rowData.service === 'freightTracking'
          ? rowData.eventType
          : rowData.operation + (rowData.eventType ? '_' + rowData.eventType : '');
      }
    },
    {
      title: 'Notification Type',
      field: 'eventType',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Workflow Name',
      field: 'service',
      headerStyle: { zIndex: 11 }
    },
    {
      title: (workflowCode && setTitle(workflowCode, 'uniqueCustomerTransactionId')) || 'Entity ID',
      field: 'uniqueCustomerTransactionId',
      headerStyle: { zIndex: 11 }
    },
    {
      title: (workflowCode && setTitle(workflowCode, 'uniqueProviderTransactionId')) || 'Provider Load ID',
      field: 'uniqueProviderTransactionId',
      headerStyle: { zIndex: 11 }
    },
    {
      title: (workflowCode && setTitle(workflowCode, 'responseStatus')) || 'Response Status',
      field: 'responseStatus',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Customer Code',
      field: 'customerCode',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Provider Code',
      field: 'providerCode',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Provider Customer Code',
      field: 'providerCustomerCode',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Aggregator',
      field: 'aggregatorCode',
      headerStyle: { zIndex: 11 }
    },
    {
      title: (workflowCode && setTitle(workflowCode, 'targetOperation')) || 'Target Operation',
      field: 'targetOperation',
      headerStyle: { zIndex: 11 }
    },
    {
      title: (workflowCode && setTitle(workflowCode, 'targetService')) || 'Target Service',
      field: 'targetService',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Response Time',
      field: 'timeTaken',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => {
        return rowData.timeTaken ? rowData.timeTaken + 'ms' : '';
      }
    },
    {
      title: (workflowCode && setTitle(workflowCode, 'requestType')) || 'Notification Type',
      field: 'requestType',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Status Code',
      field: 'statusCode',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Description',
      field: 'responseHttpStatus',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => {
        return rowData.responseHttpStatus + ' ' + (rowData.errorMessage ? rowData.errorMessage : '');
      }
    },
    {
      title: 'FT ID',
      field: 'id',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Time Stamp',
      field: 'lmd',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => moment(rowData.lmd).format('MM/DD/YYYY hh:mm:ss A')
    },
    {
      title: 'Load/Shipment ID',
      field: 'shipmentId',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Ingestion ID',
      field: 'ingestionId',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Transit Mode',
      field: 'shipmentMode',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Partner Name',
      field: 'partnerName',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Carrier Name',
      field: 'carrierName',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Planned Ship Date',
      field: 'plannedShipDate',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => moment(rowData.plannedShipDate).format('MM/DD/YYYY hh:mm:ss A')
    },
    {
      title: 'Planned Delivery Date',
      field: 'plannedDeliveryDate',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => moment(rowData.plannedDeliveryDate).format('MM/DD/YYYY hh:mm:ss A')
    },
    {
      title: 'Number of Stop',
      field: 'stops',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => {
        return rowData?.stops?.length;
      }
    },
    {
      title: 'Load Status',
      field: 'loadStatus'
    },
    {
      title: 'Retry Count',
      field: 'retryCount',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Retry Status',
      field: 'retryStatus',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Initial Http Status',
      field: 'initialHttpStatus',
      headerStyle: { zIndex: 11 }
    },
    {
      title: 'Created Time',
      field: 'createdTime',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) =>
        moment(rowData.createdTime)
          .tz(timeZone || 'UTC')
          .format('MM/DD/YYYY hh:mm:ss A')
    }
  ];
};

export const getColumns = (classes: any, type?: string, workflowCode?: string, timeZone?: string) => {
  const allColumns = allcolumns(classes, workflowCode, timeZone);
  let typeColumns: any = [];
  // Filter column based on the type(provider, customer etc) from admin columns
  switch (type) {
    case 'ADMIN':
      typeColumns = adminCoulmns;
      break;
    case 'PROVIDER':
      typeColumns = _.difference(adminCoulmns, providerColumns);
      break;
    case 'CUSTOMER':
      typeColumns = _.difference(adminCoulmns, customerColumns);
      break;
    case 'AGGREGATOR':
      typeColumns = _.difference(adminCoulmns, aggregatorColumns);
      break;
    case 'ARCHIVE':
      typeColumns = _.difference(adminCoulmns, archiveColumn);
      break;
    default:
      typeColumns = adminCoulmns;
  }

  if (!_.isEmpty(workflowCode)) {
    // filter column based on the service type
    const serviceColumn = workflowCode && workflowCodeColumn?.[workflowCode];
    if (
      workflowCode === 'freightTracking' ||
      workflowCode === 'outboundNotification' ||
      workflowCode === 'customerAccess'
    ) {
      typeColumns = serviceColumn;
    } else {
      typeColumns = _.difference(typeColumns, serviceColumn);
    }
  }
  // filter the result column from all columns
  //We will get the result as the combination of either participanta and service or admin level
  return allColumns?.filter((col: any) => typeColumns?.includes(col?.field));
};

export const subcolumns = [
  {
    title: 'FT ID',
    field: 'loadId',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Load/Shipment ID',
    field: 'shipmentId',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Shipment Line ID',
    field: 'shipmentLineId',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Ingestion ID',
    field: 'ingestionId',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Event Time',
    field: 'eventTime',
    headerStyle: { zIndex: 10 },
    render: (rowData: any) => moment(rowData.eventTime, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm:ss A')
  },
  {
    title: 'Event Type',
    field: 'eventType',
    headerStyle: { zIndex: 10 }
  }
];
